import React from 'react';


export default ({rows}) => {
  if (rows.length === 0) {
    return <div className='alert alert-warning'>Report is empty.</div>;
  }
  return (
    <table className='table' width='100%'>
      <thead>
        <tr>
          <th>Device</th>
          <th>Date</th>
          <th>Amount (L)</th>
        </tr>
      </thead>
      <tbody>
        {
          rows.map((r, i) => (
            <tr key={i}>
              <td>{r.device_name}</td>
              <td>{r.counter_date}</td>
              <td>{(r.counter_value * r.stroke_size / 10000).toFixed(3)}</td>
            </tr>
          ))
        }
      </tbody>
    </table>
  );
}
